/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */


import {
    FETCH_ORGANIZATION_METADATA_FAILURE,
    FETCH_ORGANIZATION_METADATA_REQUEST,
    FETCH_ORGANIZATION_METADATA_SUCCESS,
} from "../types/organizationMetadata";
import { OrganizationMetadata } from "../../data/interfaces";

export const fetchOrganizationMetadataRequest = () => {
    return {
        type: FETCH_ORGANIZATION_METADATA_REQUEST
    }
};

export const fetchOrganizationMetadataSuccess = (organizationMetadata : OrganizationMetadata) => {
    return {
        type: FETCH_ORGANIZATION_METADATA_SUCCESS,
        payload: organizationMetadata
    }
};

export const fetchOrganizationMetadataFailure = (error: string) => {
    return {
        type: FETCH_ORGANIZATION_METADATA_FAILURE,
        payload: error
    }
};
